export const BAR_WIDTH = 18;
